import { seoJoinSplitUrl } from 'atc-js';
export var pathByBrandEnv = {
  atc: {
    prod: '//www.autotrader.com/pixall/pix-at.min.js',
    qa: '//test.autotrader.com/pixall/pix-at.min.js'
  },
  kbb: {
    prod: '//www.kbb.com/pixall/pix-kbb.min.js',
    qa: '//staging.kbb.com/pixall/pix-kbb.min.js'
  },
  ford: {
    prod: seoJoinSplitUrl('//www', 'fordblueadvantage', 'com', '/pixall/pix-fba.min.js'),
    qa: seoJoinSplitUrl('//test', 'fordblueadvantage', 'com', '/pixall/pix-fba.min.js')
  }
};
export default pathByBrandEnv;